<template>
<!-- 通知公告 -->
  <div class="container">
    <div class="notice_cont">
      <div class="public">
        <div class="notice_list">
          <div class="notice_item" v-for="item in publishList" :key="item.id">
            <div class="notice_tit" @click="goDetail(item)">
              <p class="pad_bottom">{{item.noticeTitle}}</p>
            </div>
            <div class="notice_time">
              {{item.createTime}}
            </div>
          </div>
        </div>
      </div>
      <div v-if="!showCont" class="bot_btn">
        <van-button class="add_btn" size="large" @click="addNotice" type="primary">新增公告</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/service/modules/appraiseNew.js";
export default {
  components: {

  },
  data() {
    return {
      navList: [
        {
          type: "已发布",
          select: true
        },
        {
          type: "未发布",
          select: false
        }
      ],
      publishList: [],
      showCont: true // tab切换
    };
  },
  created() {
    this.queryList();
  },
  methods: {
    // 获取公告列表
    queryList() {
      let params = {};
      api.findAllNotice(params).then(res => {
        if (res.ret === 0) {
          this.publishList = res.data.filter(item => {
            item.createTime = item.createTime.slice(5, 16);
            return item.isPublish === 1;
          });
        }
      });
    },
    // 查看详情
    goDetail(item) {
      this.$router.push(`/appraise/noticeDetail?id=${item.id}`);
    },
  }
};
</script>

<style lang="less" scoped>
.container {
  margin-top: 16px;
  width: 100%;
  .content {
    width: 100%;
    padding: 10px 14px 0 14px;
    box-sizing: border-box;
    overflow: hidden;
    position: fixed;
    top: 0;
    background-color: rgba(251,251,251,1);;
    z-index: 99;
    .nav {
      width: 100%;
      height: 40px;
      .wrapper {
        white-space: nowrap;
        position: absolute;
        .item {
          display: inline-block;
          padding: 10px;
          // border-bottom: 2px solid @base-color;
          font-size: 14px;
        }
        .item_active {
          border-bottom: 2px solid @base-color;
          padding-bottom: 6px;
          color: @base-color;
          font-weight: 600;
          padding-left: 0;
          padding-right: 0;
          margin: 0 10px;
        }
      }
    }
  }
  .bgWhite {
    background-color: #fff;
  }
  .bgGray {
    background-color: #fbfbfb;
  }
  .fiedBox {
    height: 50px;
    width: 100%;
  }
  .child-view {
    margin-top: 1px;
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 50px;
    line-height: 50px;
    margin-top: 50px;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .notice_list {
    margin: 0 12px;
    width:351px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 15px 0px rgba(0,0,0,0.06);
    border-radius:3px;
    .notice_item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #ededed;
    }
    .notice_item:last-child {
      border-bottom: 0;
    }
    .notice_tit {
      width: 211px;
      
    }
    .notice_tit p {
      font-size:14px;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height:22px;
      overflow:hidden; 
      word-break: break-all;
      text-overflow:ellipsis;
      display:-webkit-box; 
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2; 
    }
    // .pad_bottom {
    //   padding-bottom: 8px;
    // }
    .notice_btn {
      font-size: 0;
      img {
        display: inline-block;
        width: 14px;
        height: 14px;
        vertical-align: middle;
      }
      span {
        display: inline-block;
        margin-left: 4px;
        font-size:14px;
        font-weight:400;
        color:rgba(54,179,116,1);
        vertical-align: middle;
      }
      .delete_btn {
        margin-right: 16px;
      }
    }
    .notice_time {
      font-size: 14px;
      color: #999;
      font-weight: 400;
    }
  }
  .bot_btn {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 12px;
    width: 100%;
    height: 60px;
    background:rgba(255,255,255,1);
    box-shadow:0px -2px 8px 0px rgba(0,0,0,0.03);
  }
  .bot_btn .add_btn {
    width: 351px;
    height: 40px;
    background-color: #36B374;
  }
}
</style>
